<template>
  <div>
    <CContainer>
      <CRow class="justify-content-center mt-4">
        <CCol col="12" md="8" xl="6" class="text-center">
          <h1 class="mb-4">
            Limit Active Passes
            <HelpCenterButton classes="me-2" content-key="active_pass_limit" />
          </h1>
          <CreateLimitActivePassForm is-in-view="true" />
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import CreateLimitActivePassForm from "@/components/Forms/CreateLimitActivePassForm"
import HelpCenterButton from "@/components/HelpCenterButton"

export default {
  name: "LimitActivePasses",
  components: { CreateLimitActivePassForm, HelpCenterButton }
}
</script>
